import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-select-item-lista',
  templateUrl: './select-item-lista.component.html',
  styleUrls: ['./select-item-lista.component.scss'],
})
export class SelectItemListaComponent implements OnInit {

  @Input() catalogo: any = [];
  @Input() nombre: 'strNombre';
  @Input() descripcion: 'strDescripcion';
  @Input() titulo: 'Elija una opción';
  @Input() color = 'warning';
  strBusqueda = '';
  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() { }


  onClick(item: any) {
    this.popoverController.dismiss(item);
  }

  buscar(event) {
    console.log({ event });

    this.strBusqueda = event.detail.value;
  }

}
